import React, { useRef } from 'react';
import Globals from '../../../utility/constants/appConstants';
import ToolTip from '../../ui/toolTip';

const PrePay = (props) => {
    const tooltipRef = useRef(null);
    const {prepayDspSvcCntFlag , prepayDspSvcCnt, arBalance , labels, paymentsCss, isActionEnabled } = props;
    const {prePaid, amountDue, tooltipheading1, tooltipheading2, tooltipdata, tooltipsmbl, dollarsPP, centsPP  } = labels;

    return (
      <>
        <div className={`${paymentsCss["bg-white"]} col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-end bg-white position-relative p-0 ${paymentsCss["tru-mma-main-side"]}`}>
          
            <div className={`align-items-center d-flex flex-column flex-fill justify-content-center ${paymentsCss["p-10"]} ${paymentsCss["glh-1_2"]}`}>
                <span className={`d-block ${paymentsCss["gfs-14"]} ${paymentsCss['gfw-3']} ${paymentsCss["gfs-lg-16"]} mb-2 ${paymentsCss["text-green"]}`}>{prePaid}</span>
              <span className={`d-block ${paymentsCss["gfs-14"]}  ${paymentsCss["gfw-3"]} ${paymentsCss["gfs-lg-16"]}`}>{amountDue}</span>
              <span className={`d-block ${paymentsCss["gfs-50"]} ${paymentsCss["gfs-md-26"]} ${paymentsCss["gfw-7"]} ${paymentsCss["text-green"]}`}>
                <span className={`${paymentsCss["gfs-48"]}`}>{Globals.currencySymbol}{dollarsPP}</span>
                <sup className={`${paymentsCss["gfs-26"]} tg-ml-2`}
                >{centsPP}</sup>
              </span>
            </div>
          
          <ToolTip  toolTip={prepayDspSvcCntFlag === 'Y' ? tooltipheading1  + prepayDspSvcCnt : tooltipheading2 + Globals.currencySymbol + -1*arBalance } tooltipdata={tooltipdata} tooltipsmbl={labels.tooltipsmbl} parentCss={paymentsCss} />
        </div>
      </>
    );
}

export default PrePay;